// バックエンド AddJobNumberSchema と同じ制約。スラッシュ等が混入すると DELETE のパスパラメータが
// 分断され、そのレコードを削除できなくなるため文字種を制限する。
export const JOB_NUMBER_PATTERN = /^[A-Za-z0-9-]+$/;

// バックエンド AddJobNumberSchema の max(255) に合わせた入力上限。
export const JOB_NUMBER_MAX_LENGTH = 255;

// 画面表示用のセグメント区分名。キーはバックエンドのセグメントマスター（call_setting_segment.code）に対応する。
// 未知のセグメントが来た場合は利用側で code をそのまま表示するため、ここには既知の値のみを定義する。
export const SEGMENT_LABEL: Record<string, string> = {
  mobile: 'モバイル',
  office: 'オフィス',
  tokyo: '東京',
  osaka: '大阪',
};
